var $d5706227c7017a61$exports = {};
$d5706227c7017a61$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$d5706227c7017a61$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
